/**
 * @fileoverview Input/output schemas for the genre-detector-v2 agent.
 *
 * This agent detects genres from a text sample by analyzing its style,
 * content, and conventions against a list of available genre templates.
 */

import { z } from 'zod';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Flow Input Schema - full input for the agent flow.
 */
export const InputSchema = z.object({
  logId: z.string(),
  model: z.string(),
  customPrompt: z.string(),
  text: z.string().min(1).describe('The text to analyze for genre detection (will be truncated to first 50k characters).'),
  availableGenreIds: z.array(z.string()).describe('List of available genre template IDs to choose from.'),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

/**
 * Output Schema - detected genres with explanation.
 */
export const OutputSchema = z.object({
  detectedGenreIds: z.array(z.string()).describe('The genre template IDs that best match the writing sample (1-3 genres).'),
  explanation: z.string().describe('Brief explanation of why these genres were detected.'),
});

export type Output = z.infer<typeof OutputSchema>;
